import { render, staticRenderFns } from "./VideoSwiper.vue?vue&type=template&id=45451548&scoped=true&"
import script from "./VideoSwiper.vue?vue&type=script&lang=js&"
export * from "./VideoSwiper.vue?vue&type=script&lang=js&"
import style0 from "./VideoSwiper.vue?vue&type=style&index=0&id=45451548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45451548",
  null
  
)

export default component.exports